import { render, staticRenderFns } from "./AdminOrgMajor.vue?vue&type=template&id=3eef7fd3&scoped=true&"
import script from "./AdminOrgMajor.vue?vue&type=script&lang=js&"
export * from "./AdminOrgMajor.vue?vue&type=script&lang=js&"
import style0 from "./AdminOrgMajor.vue?vue&type=style&index=0&id=3eef7fd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eef7fd3",
  null
  
)

export default component.exports